import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Layout from 'components/Layout'
import { FolderKanban } from 'lucide-react'
import Popup from 'components/Popup'
import ProjectModifyPopup from 'components/popups/ProjectModifyPopup'
import { patchLocation } from 'slices/locationSlice'
import { initializeProjects, patchProject } from 'slices/projectSlice'

const SidebarProjectTop = ({ location, project, originator }) => {
	const dispatch = useDispatch()

	const [openModifyPopup, setOpenModifyPopup] = useState(false)
	const [recordForEdit, setRecordForEdit] = useState(null)
	const [popupTitle, setPopupTitle] = useState(null)

	const userLogin = useSelector(state => state.userLogin)
	const { userInfo } = userLogin

	const locationId = location?._id

	useEffect(() => {
		// dispatch(initializeApiKey('REACT_APP_GOOGLE_API_KEY'))
	}, [dispatch, locationId])

	if (!location || !project) {
		return null
	}

	const openProjectEdit = projectRecord => {
		setRecordForEdit(projectRecord)
		setPopupTitle('Edit Project')
		setOpenModifyPopup(true)
	}

	const handleEditProject = async newProject => {
		await dispatch(
			patchProject({
				projectId: newProject._id,
				updates: {
					projectName: newProject.projectName,
					projectDescription: newProject.projectDescription,
					projectType: newProject.projectType,
					isActive: newProject.isActive,
					image: location.image,
					updateNote: 'Project edited.',
				},
			}),
		)
		dispatch(
			initializeProjects({
				locationId,
			}),
		)

		setOpenModifyPopup(false)
		dispatch(patchLocation({ locationId, updates: { updateNote: 'Project Edited' } }))
	}

	return (
		<div>
			<Layout.SidebarAssetTop
				image={location.image}
				assetName={
					project.owner?._id === userInfo._id ? (
						<div
							className="font-semibold hover:no-underline hover:scale-110 cursor-pointer transition-transform duration-150"
							onClick={() => openProjectEdit(project)}
						>
							{project.projectName}{' '}
						</div>
					) : (
						<div className="text-lg font-semibold">{project.projectName}</div>
					)
				}
				originator={
					<div>
						<div className="pt-2">
							{originator}
							{project.owner?.name}
						</div>
					</div>
				}
			/>
			{openModifyPopup ? (
				<Popup title={popupTitle} openPopup={openModifyPopup} setOpenPopup={setOpenModifyPopup} icon={<FolderKanban className="w-5 h-5" />} description="Modify project details">
					<ProjectModifyPopup editProject={handleEditProject} recordForEdit={recordForEdit} />
				</Popup>
			) : null}
		</div>
	)
}

export default SidebarProjectTop
